<template>
  <el-card shadow="hover" :body-style="{padding:'5px'}" class="lesson">
    <div class="header">
      <p class="omit" :title="title">{{title}}</p>
    </div>
    <div v-if="describe" class="time">
      <i v-if="!isPractice" class="el-icon-tickets"></i>
      <p>{{describe}}</p>
    </div>
    <div v-if="time" class="time">
      <i class="el-icon-time"></i>
      <p>{{time}}</p>
    </div>
    <div class="seal" v-if="status != 1 && history_count > 0">
      <img src="@p/assets/images/disable.png" alt="" />
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    imgSrc: {
      type: String,
    },
    title: {
      type: String,
      default: 'Lesson'
    },
    time: {
      type: String,
      default: ''
    },
    describe: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'el-icon-circle-check'
    },
    styles: {
      type: [String, Object],
      default: ''
    },
    isPractice: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number,
      default: 1
    },
    history_count: {
      type: Number,
      default: 0
    },
  },
}
</script>
<style lang="less" scoped>
.lesson {
  position: relative;
  width: 230px;
  height: 150px;
  background: rgba(77, 142, 246, 0.1);
  .seal {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 42px;
    height: 40px;
    img {
      width: 42px;
      height: 40px;
    }
  }
  .header {
    width: 220px;
    height: 40px;
    text-align: center;
    color: #fff;
    font-weight: 600;
    font-size: 17px;
    line-height: 40px;
    margin-bottom: 20px;
    background-color: #4d8ef6;
  }
  .time {
    display: flex;
    margin-top: 10px;
    height: 13px;
    width: 230px;
    font-size: 13px;
    line-height: 13px;
    color: rgba(51, 51, 51, 0.5);
    p {
      margin-left: 4px;
    }
  }
}
</style>